import VipProductList from "../views/productManagement/vipProductList";
import ProductBenefitList from "../views/productManagement/productBenefitList";
import IntegralConfigure from "../views/productManagement/integralConfigure";
import IntegralExchange from "../views/productManagement/integralExchange";
import MarqueeList from "../views/productManagement/marqueeList";
import BannerActivityList from "../views/productManagement/bannerActivityList";
import GlodList from "../views/productManagement/glodList";
import GameGlodList from "../views/productManagement/gameGlodList";
import CurrencyList from "../views/productManagement/currencyList";
import GlodPayList from "../views/productManagement/glodPayList";
import PromoteUrl from "../views/productManagement/promoteUrl";
import PayMethod from "../views/productManagement/payMethod";
import VipCfg from "../views/productManagement/vipCfg";
import Main from "../views/main";
import ProductPositionList from "../views/productManagement/productPositionList";
import OfficialList from "../views/productManagement/officialList";
const ProductRouter = {
  path: "/vip-product-list",
  component: Main,
  title: "产品管理",
  icon: "el-icon-s-order",
  meta: { keepAlive: true },
  children: [
    {
      path: "/vip-product-list",
      component: VipProductList,
      name: "vipProductList",
      title: "VIP商品列表",
      meta: { title: "VIP商品列表", keepAlive: true },
    },
    {
      path: "/product-benefit-list",
      component: ProductBenefitList,
      name: "productBenefitList",
      title: "VIP权益列表",
      meta: { title: "VIP权益列表", keepAlive: true },
    },
    {
      path: "/integral-configure",
      component: IntegralConfigure,
      name: "integralConfigure",
      title: "积分配置",
      meta: { title: "积分配置", keepAlive: true },
    },
    {
      path: "/integral-exchange",
      component: IntegralExchange,
      name: "integralExchange",
      title: "积分兑换",
      meta: { title: "积分兑换", keepAlive: true },
    },
    {
      path: "/marquee-list",
      component: MarqueeList,
      name: "marqueeList",
      title: "跑马灯列表",
      meta: { title: "跑马灯列表", keepAlive: true },
    },
    {
      path: "/banner-activity-list",
      component: BannerActivityList,
      name: "bannerActivityList",
      title: "banner活动列表",
      meta: { title: "banner活动列表", keepAlive: true },
    },
    {
      path: "/glod-list",
      component: GlodList,
      name: "glod-list",
      title: "金币列表",
      meta: { title: "金币列表", keepAlive: true },
    },
    {
      path: "/gameGlod-list",
      component: GameGlodList,
      name: "gameGlod-list",
      title: "游戏金币列表",
      meta: { title: "游戏金币列表", keepAlive: true },
    },
    {
      path: "/currency-list",
      component: CurrencyList,
      name: "currency-list",
      title: "货币列表",
      meta: { title: "货币列表", keepAlive: true },
    },
    {
      path: "/glod-pay-list",
      component: GlodPayList,
      name: "glod-pay-list",
      title: "金币优惠配置",
      meta: { title: "金币优惠配置", keepAlive: true },
    },
    {
      path: "/promote-url",
      component: PromoteUrl,
      name: "promote-url",
      title: "推广落地页配置",
      meta: { title: "推广落地页配置", keepAlive: true },
    },
    {
      path: "/pay-method",
      component: PayMethod,
      name: "payMethod",
      title: "充值渠道管理",
      meta: { title: "充值渠道管理", keepAlive: true },
    },
    {
      path: "/productPosition-list",
      component: ProductPositionList,
      name: "productPositionList",
      title: "产品位置配置",
    },
    {
      path: "/vip_Cfg",
      component: VipCfg,
      name: "vipCfg",
      title: "VIP升级配置",
    },
    {
      path: "/official-list",
      component: OfficialList,
      name: "officialList",
      title: "官方下载列表",
      meta: { title: "官方下载列表", keepAlive: true },
    },
  ],
};
export default ProductRouter;
